import { createFileRoute } from '@tanstack/react-router';
import { RelatorioCadastroRelacaoFornecedores } from '@/features/relatorio/page/cadastro/relacao-fornecedores/RelatorioCadastroRelacaoFornecedores';

export const Route = createFileRoute('/a/relatorio/cadastro/relacao-fornecedores')({
    component: RelatorioCadastroRelacaoFornecedores,
});
